export default [
    {
        path: "/admin/assign-duty/create",
        component: () => import("@/App/Duty/AssignDuty/Components/Create.vue"),
        name: "duty-assign-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/monthly-user-assign-duty",
        component: () => import("@/App/Duty/AssignDuty/Components/UserMonthlyDuty.vue"),
        name: "user-duty-assign",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/assign-duty-day",
        component: () => import("@/App/Duty/AssignDuty/Components/List.vue"),
        name: "duty-assign-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/assign-duty-night",
        component: () => import("@/App/Duty/AssignDuty/Components/NightShift.vue"),
        name: "duty-assign-night-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/assign-duty-all-day",
        component: () => import("@/App/Duty/AssignDuty/Components/AllDay.vue"),
        name: "duty-assign-all-day-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/assign-duty-outside",
        component: () => import("@/App/Duty/AssignDuty/Components/OutSideDuty.vue"),
        name: "duty-assign-outside",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/no-duty-update",
        component: () => import("@/App/Duty/AssignDuty/Components/NoDutyUpdate.vue"),
        name: "no-duty-update",
        meta: {
            requiresAuth: true,
        },
    },
];
